import * as TYPES from '../types';

const initialState = {
    teamMemberList: [],
    teamTypeList: [],
};

export function TeamReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {

        case TYPES.GET_ALL_TEAM_TYPE_SUCCESS:
            return {
                ...preState,
                teamTypeList: payload,
            };

        case TYPES.GET_ALL_TEAM_MEMBER_SUCCESS:
            return {
                ...preState,
                teamMemberList: payload,
            };

        default:
            return state;
    }
}